import { API_KEY, DASHBOARD_MENU_KEY, DATA_SHEET_MENU_KEY, RESULT_PROCESSING_MENU_KEY } from "./menu.keys";
import type { TFunction } from "i18next";
import { BROWSER_ROUTES } from "@constants/browser.routes";
import WidgetsOutlinedIcon from "@mui/icons-material/WidgetsOutlined";
import HistoryEduOutlinedIcon from '@mui/icons-material/HistoryEduOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import ConnectWithoutContactOutlinedIcon from '@mui/icons-material/ConnectWithoutContactOutlined';

export const getSidebarMenuConfig = (t: TFunction) => {
	return [
		{
			key: DASHBOARD_MENU_KEY,
			label: t("layout.sidebar.menuName.dashboard"),
			icon: <WidgetsOutlinedIcon fontSize="medium" />,
			route: BROWSER_ROUTES.DASHBOARD,
		},
		{
			key: RESULT_PROCESSING_MENU_KEY,
			label: t("layout.sidebar.menuName.resultProcessing"),
			icon: <HistoryEduOutlinedIcon fontSize="medium" />,
			route: BROWSER_ROUTES.RESULT_PROCESSING,
		},	
		{
			key: DATA_SHEET_MENU_KEY,
			label: t("layout.sidebar.menuName.dataSheet"),
			icon: <CalendarMonthOutlinedIcon fontSize="medium" />,
			route: BROWSER_ROUTES.DATA_SHEET,
		},	
		{
			key: API_KEY,
			label: t("layout.sidebar.menuName.api"),
			icon: <ConnectWithoutContactOutlinedIcon fontSize="medium" />,
			route: BROWSER_ROUTES.API,
		},

		
	];
};
